import {observer} from "mobx-react";
import React, {useEffect, useState} from "react";
import {callAndReload, callWithCatch} from "~/utils.js";
import _ from "lodash";
import {message, Spin} from "antd";
import XhrBtn from "~/components/XhrBtn.js";
import GroupsSelector from "~/components/GroupsSelector.js";
import {KnockoutFlex} from "~/apps/tournament/KnockOut.js";

export default observer(({d}) => {
    const [tempGroups, setTempGroups] = useState([]);
    const [bracket, setBracket] = useState(null);
    // const [takeToPlayoff, setTakeToPlayoff] = useState(null);
    let [lanes, setLanes] = useState();

    let teams = tempGroups && tempGroups[0];

    let load = (team_ids, bracket, settings = {}) => {
        callWithCatch({
            url: `/divisions/${d.id}/playoff_simulation`,
            params: { 
                team_ids, 
                bracket,
                take_to_playoff: settings.take_to_playoff,
                playoff_style: settings.playoff_style,
                match_format: settings.match_format,
                rounds_format: settings.rounds_format
            },
            method: 'get',
            onSuccess: data => {
                setTempGroups([data.teams.map(((t, i) => ({...t, name: `${i+1}. ${t.name}`})))]);
                setLanes(data.lanes);
                setBracket(data.bracket_format)
                // setTakeToPlayoff("" + data.take_to_playoff)
            }
        })
    };

    useEffect(() => {
        load();
    }, []);

    let onDrop = items => {
        // pp(tempGroups)
        setTempGroups(_.cloneDeep(tempGroups));
        load(tempGroups[0].map(t => t.id));
    }

    let genPlayoff = async () => {
        await callAndReload({
            url: '/divisions/' + d.id,
            params: { gen_playoff: true, groups: tempGroups.map(g => g.map(t => t.id)) },
            reload: true,
            onSuccess: () => message.success("Playoff Generated"),
            method: 'put',
        })
    }

    if (!lanes)
        return <div>Loading  <Spin /></div>;

    // let changeTakeToPlayoff = e => {
    //   let n = e.target.value;
    //   setTakeToPlayoff(n);
    //   load(tempGroups[0].map(t => t.id), bracket, n);
    // }

    let changeBracket = e => {
        let n = e.target.value;
        setBracket(n);
        load(tempGroups[0].map(t => t.id), n);
    }

    return <div className="flex flex-row gap-8">
        <div className="space-y-4">
            {/*<Radio.Group optionType="button" buttonStyle="solid" value={bracket} onChange={changeBracket}>*/}
            {/*  <Radio value="bracket">Bracket</Radio>*/}
            {/*  <Radio value="every_2">Finals Round Only</Radio>*/}
            {/*</Radio.Group>*/}

            <div><XhrBtn onClick={genPlayoff} type="primary" size="large" block>Generate Playoff</XhrBtn></div>
            <GroupsSelector groups={tempGroups} onDrop={onDrop} name="Seed Order"/>
        </div>
        <div className="bg-white overflow-x-auto" style={{width: "450px"}}>
            <KnockoutFlex lanes={lanes} />
        </div>
    </div>
});
